import React, { useEffect } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"

import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import FIELDS from "./CONSTANT"
import ContactForm from "./ContactForm"
import * as Yup from "yup"
import {addContact} from '../../../../api/contact'
import { useParams } from "react-router-dom"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null,
    'date': null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ||  "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")

    }else{
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
    }
})




const AddContact = () => {
    const { t } = useTranslation()
    let navigate = useHistory()
    const {id: companyId} = useParams()

    const { setData, loading, error, success } = useResponse(addContact, () => {
        navigate.goBack()
    })


    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues,
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: data => {
           data.companyId = companyId
            setData({ data, type: "add" })
        },
    })


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Contacts")}
                        breadcrumbItem={t("Add") + " " + t("Contact")}
                    />
                    
                                    <Form
                                        className="needs-validation"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <ContactForm validation={validation} />

                                        <FormButtonHandler btnTxt="Add" loading={loading} />

                                        <ResultHandler
                                            error={error}
                                            success={success}
                                            successMsg={"Created Successfully!"}
                                        />
                                    </Form>
                               
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddContact